{ partitionAndSort } = require '../../utils'

module.exports = () ->
  return {
    scope:
      isDisabled: "&stateChangeIsDisabled"
      project: "="
      states: "="
      onStateChange: "&"

    controller: ($scope, $uibModal, Api, User) ->
      if $scope.states
        $scope.statesById = partitionAndSort($scope.states, 'id', 'id')

      $scope.filterStates = (state) ->
        if state.id in ($scope.statesById[$scope.project.state]?[0].next_state or [])
          return true
        false

      $scope.nextStates = (states) ->
        (state for state in states when $scope.filterStates(state))

      $scope.countStates = (states) ->
        (s for s in states or [] when $scope.filterStates(s)).length

      $scope.showStates = (states) ->
        $scope.countStates(states) > 0 or $scope.project.state > 0

      $scope.$watch 'states', (states) ->
        if states
          $scope.statesById = partitionAndSort(states, 'id', 'id')

      changeState = (newState) ->
        oldState = $scope.project.state
        $scope.project.state = newState

        (new Api.Project id: $scope.project.id, state: $scope.project.state).$update()
          .catch(-> $scope.project.state = oldState)
          .finally(->
            $scope.saveLock = false
            $scope.onStateChange()
        )

      $scope.changeState = (newState) ->
        if $scope.saveLock
          return

        $scope.saveLock = true
        currentState = $scope.statesById[$scope.project.state]?[0]

        if (currentState?.message_on_change)
          stateChangeModal = $uibModal.open({
            template:  require("../StateChangeModal/state-change-modal.html")
            controller: "StateChangeModalController",
            resolve:
              message: () -> currentState.message_on_change
          })

          stateChangeModal.result.then(
            () ->
              changeState(newState)
            () ->
              $scope.saveLock = false
          )
        else
          changeState(newState)

      $scope.isCurrentState = ( state ) ->
        state.id is $scope.project.state

      $scope.isStateAllowed = ( state ) ->
        return state.id in User.allowed_states

      $scope.isStateDisabled = ( state ) ->
        $scope.isCurrentState( state ) or not $scope.isStateAllowed( state ) or not (state in $scope.nextStates( $scope.states ))


    template: require('./state-change.html')
  }
